import { useApiGet } from '../../../../services/tanstackApiService';

// ----------------------
// Types for patient-level invoice logs
// ----------------------

export interface PatientInvoiceLogItem {
  history_id: number;
  history_date: string;
  history_type: string;
  history_type_display: string;
  user_name: string;
  bill_number: string | null;
  visit_date: string | null;
  status: string;
  bill_type: string | null;
  invoice_patient_type: string;
  total_amount: string | number | null;
  concession_amount: string | number | null;
  tax_amount: string | number | null;
  net_amount: string | number | null;
  paid_amount: string | number | null;
  balance_amount: string | number | null;
  remark: string | null;
  clinic_name: string;
  clinic_id: number;
  provider_name: string;
  provider_id: number;
  id?: number | null;
}

export interface PatientInvoiceLogsMeta {
  limit: number;
  next: string | null;
  offset: number;
  previous: string | null;
  total_count: number;
}

export interface PatientInvoiceLogsResponse {
  meta: PatientInvoiceLogsMeta;
  objects: PatientInvoiceLogItem[];
  patient_id: string;
  patient_name: string;
  patient_mrn: string;
  total_invoices: number;
  total_changes: number;
}

export interface PatientInvoiceLogsFilters {
  patient_id?: number | null;
  limit?: number;
  offset?: number;
  search_query?: string;
}

export const patientInvoiceLogsKey = (
  patientId: number | string | null,
  page: number,
  limit: number,
  search?: string,
) => ['invoices', 'logs', 'patient', patientId ?? 0, { page, limit, search }] as const;

const patientInvoiceLogsPath = 'invoices/logs/';

export interface UsePatientInvoiceLogsParams {
  patientId: number | string | null;
  page: number;
  limit: number;
  search?: string;
  enabled?: boolean;
}

export const usePatientInvoiceLogsQuery = ({
  patientId,
  page,
  limit,
  search,
  enabled = true,
}: UsePatientInvoiceLogsParams) => {
  const offset = (page - 1) * limit;

  return useApiGet<PatientInvoiceLogsResponse>(
    patientInvoiceLogsKey(patientId, page, limit, search),
    {
      path: patientInvoiceLogsPath,
      query: {
        patient_id: patientId ?? undefined,
        limit,
        offset,
        search_query: search || undefined,
      },
    },
    {
      enabled: enabled && !!patientId,
    },
  );
};
